import { extractPrice } from './extractPrice'
import { isPricePartiallyFilled } from './isPricePartiallyFilled'
import { hasEmptyPricesInCategory } from './hasEmptyPricesInCategory'

export const priceIsOk = price => price !== null && +price >= 0
export { extractPrice, isPricePartiallyFilled, hasEmptyPricesInCategory }
